import { Router } from 'express';

export function healthRouter(checkDb: () => Promise<boolean>) {
  const router = Router();
  router.get('/health', async (_req, res) => {
    const dbUp = await checkDb();
    res.status(dbUp ? 200 : 503).json({
      status: dbUp ? 'ok' : 'degraded',
      database: dbUp ? 'up' : 'down',
      time: new Date().toISOString(),
      version: process.env.npm_package_version ?? '0.0.1',
    });
  });
  return router;
}
